export default __webpack_public_path__ + "3a2261cf44e2ad9e98ad215c83521fd6.png";